import axios from '../plugins/axios';
import queryString from 'query-string';
import qs from 'qs';

export default {
  loadIntranetList() {
    const url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + `/v1/categories/gnb`;
    const options = {
      headers: {
        'No-Jsonapi': 'true',
      },
    };
    return axios.get(url, options);
  },
  loadBookmarkList() {
    const url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + `/v1/categories/user`;
    const options = {
      headers: {
        'No-Jsonapi': 'true',
      },
    };
    return axios.get(url, options);
  },
  setIntranetVisible(bookmarkCategoriesNo) {
    let url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + '/v1/categories/toggle-visible';
    const data = qs.stringify({
      no: bookmarkCategoriesNo,
    });
    const options = {
      headers: {
        'No-Jsonapi': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.put(url, data, options);
  },
  setBookmarkVisible(bookmarkCategoriesNo) {
    let url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + '/v1/categories/user/toggle-visible';
    const data = qs.stringify({
      no: bookmarkCategoriesNo,
    });

    const options = {
      headers: {
        'No-Jsonapi': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.put(url, data, options);
  },
  createBookmark(name, bookmarkUrl) {
    let url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + '/v1/categories/user/bookmark';
    const data = qs.stringify({
      bookmark: {
        name: name,
        url: bookmarkUrl,
      },
    });
    const options = {
      headers: {
        'No-Jsonapi': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return axios.post(url, data, options);
  },
  removeBookmark(no) {
    let url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + '/v1/categories/user';

    const options = {
      params: {
        no: no,
      },
    };
    return axios.delete(url, options);
  },
  modifyBookmark(no, name, bookmarkUrl) {
    let url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + '/v1/categories/user/bookmark';

    const data = qs.stringify({
      no: no,
      bookmark: {
        name: name,
        url: bookmarkUrl,
      },
    });
    const options = {
      headers: {
        'No-Jsonapi': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return axios.put(url, data, options);
  },
  modifyBookmarkOrder(noList) {
    let url = process.env.VUE_APP_HIWORKS_BOOKMARK_API + '/v1/categories/user/move';

    // qs의 버그로 인해 해당 api만 query-string 사용
    const data = queryString.stringify(
      {
        order: noList,
      },
      { arrayFormat: 'bracket' },
    );

    const options = {
      headers: {
        'No-Jsonapi': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    return axios.put(url, data, options);
  },
};
